<template>
  <v-dialog v-model="dialog" max-width="600">
    <v-card class="coming-soon-modal">
      <v-card-title>
        <h2 class="font card-title">¡Aviso!</h2>
      </v-card-title>
      <v-card-text class="font card-text">
        Esto es una funcionalidad solamente disponible en la versión paga.<br>Conocé más en <a @click="openPoncePage">{{VUE_APP_LANDING_PAGE_URL}}</a>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    data () {
      return {
        VUE_APP_LANDING_PAGE_URL: process.env.VUE_APP_LANDING_PAGE_URL
      };
    },
    props: {
      dialog: {
        type: Boolean,
        default: false
      }
    },
    computed: {
    },
    watch: {
      dialog (val) {
        this.$emit('update:dialog', !!val);
      }
    },
    methods: {
      openPoncePage () {
        window.open(
          process.env.VUE_APP_LANDING_PAGE_URL,
          '_blank'
        );
      }
    }
  };
</script>


// WEBPACK FOOTER //
// ComingSoonModal.vue?46065308